import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { HTTP_STATUS_CODE_403 } from '../constants/httpStatusCode';
import handleDisplayErrorToast from '../utils/handleDisplayErrorToast';

const fetchTopics = ({
  format = 'json',
  page = 1,
  v2 = false,
  cancelToken,
  ...params
}) => {
  let path = Routes.topics_topics_path({ format, page, ...params });

  if (v2) {
    path = Routes.topics_topics_v2_index_path({ format, page, ...params });
  }

  return axios
    .get(path, {
      cancelToken: cancelToken.token,
    })
    .then(({ data: { topics, total_items: total } }) => ({
      total,
      topics,
    }))
    .catch((error) => {
      if (error.message === CANCEL_FETCH_MESSAGE) {
        return null;
      }

      if (error?.response?.status !== HTTP_STATUS_CODE_403) {
        handleDisplayErrorToast(error);
      }

      return error;
    });
};

export default fetchTopics;
